(function () {
    'use strict';

    angular
        .module('procedureRoutes', [
            'procedureControllers'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {

        $stateProvider

            // Procedure Home
            .state('procedure', {
                url: '/Procedure',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                abstract: true,
                views: {
                    '': {
                        template: '<div class="row"><div ui-view="govProcedure"></div></div>',
                        controller: 'ProcedureController'
                    }
                }
            })

            // Procedure Add
            .state('procedure.add', {
                url: '/Add?procedureType,procedureTypeId,committeeId',
                data: {
                    permissions: {featureRole: 'ProceduresManagement', key: 'Procedure', permission: 'Create'}
                },
                views: {
                    'govProcedure@procedure': {
                        resolve: {
                            procedure: ['$stateParams', 'procedureService', function ($stateParams, service) {
                                // Get default data for terms of reference, when a committee ID is defined
                                if (
                                    $stateParams.committeeId
                                    && $stateParams.procedureType
                                    && (
                                        $stateParams.procedureType === 'Terms-Of-Reference'
                                        || $stateParams.procedureType === 'Terms-Of-Reference-Steering'
                                    )
                                ) {
                                    return service
                                        .getProcedureDraft($stateParams.procedureType, $stateParams);
                                }

                                var data = {
                                    MetadataBlock: {
                                        LegalEntities: [],
                                        Locations: []
                                    }
                                };

                                if ($stateParams.procedureTypeId) {
                                    data.MetadataBlock.ProcedureTypeID = Number($stateParams.procedureTypeId);
                                }

                                return data;
                            }],
                            metadataBlockLookups: ['procedureService', function (service) {
                                return service.getAllMetadataBlockLookupAttributes();
                            }],
                            sectionBlockLookups: ['procedureService', function (service) {
                                return service.getAllSectionBlockLookupAttributes();
                            }],
                            businessUnits: ['procedureService', function (service) {
                                return service.getAllBusinessUnits();
                            }],
                            procedureTypes: ['procedureService', function (service) {
                                return service.getProcedureTypesForCreation();
                            }]
                        },
                        templateUrl: require('./procedureEditMetadata.tpl.html'),
                        controller: 'ProcedureEditMetadataController'
                    }
                }
            })

            // State to redirect old URLs that may have been linked from outside of GOV
            .state('procedure.redirectWithType', {
                url: '/{ProcedureCode}/Published',
                resolve: {
                    procedure: ['procedureService', '$stateParams', function (service, $stateParams) {
                        return service.getProcedureForRedirection($stateParams.ProcedureCode);
                    }]
                },
                views: {
                    'govProcedure@procedure': {
                        controller: 'ProcedureRedirectionController'
                    }
                }
            })

            // Procedure View Sections
            .state('procedure.viewPublished', {
                url: '/{ProcedureType}/{ProcedureCode}/Published',
                views: {
                    'govProcedure@procedure': {
                        resolve: {
                            sectionBlockLookups: ['procedureService', function (service) {
                                return service.getAllSectionBlockLookupAttributes();
                            }],
                            procedure: ['procedureService', '$stateParams', function (service, $stateParams) {
                                return service.getPublishedProcedureView($stateParams.ProcedureType, $stateParams.ProcedureCode);
                            }],
                            permissions: ['permissionService', 'procedure', function (permissionService, procedure) {
                                return permissionService.hasPermission('ProceduresManagement', 'Procedure', 'View', procedure);
                            }]
                        },
                        templateUrl: require('./procedureSectionList.tpl.html'),
                        controller: 'ProcedureSectionListController'
                    }
                }
            })

            // Procedure View Working Copy
            .state('procedure.view', {
                url: '/{ProcedureType}/{ProcedureCode}/WorkingCopy?lang',
                views: {
                    'govProcedure@procedure': {
                        resolve: {
                            sectionBlockLookups: ['procedureService', function (service) {
                                return service.getAllSectionBlockLookupAttributes();
                            }],
                            procedure: ['procedureService', '$stateParams', function (service, $stateParams) {
                                return service.getWorkingCopyProcedureView($stateParams.ProcedureType, $stateParams.ProcedureCode);
                            }],
                            permissions: ['permissionService', 'procedure', function (permissionService, procedure) {
                                return permissionService.hasPermission('ProceduresManagement', 'Procedure', 'View', procedure);
                            }]
                        },
                        templateUrl: require('./procedureSectionList.tpl.html'),
                        controller: 'ProcedureSectionListController'
                    }
                }
            })

            // Procedure Edit Sections
            .state('procedure.edit', {
                url: '/{ProcedureType}/{ProcedureCode}/Edit',
                resolve: {
                    procedure: ['procedureService', '$stateParams', function (service, $stateParams) {
                        return service.getProcedureForEdit($stateParams.ProcedureType, $stateParams.ProcedureCode);
                    }],
                    sectionBlockLookups: ['procedureService', function (service) {
                        return service.getAllSectionBlockLookupAttributes();
                    }]
                },
                views: {
                    'govProcedure@procedure': {
                        templateUrl: require('./procedureSectionListEdit.tpl.html'),
                        controller: 'ProcedureSectionListEditController'
                    }
                }
            })

            // Procedure Edit Metadata
            .state('procedure.edit.metadata', {
                url: '/Metadata',
                resolve: {
                    procedure: ['procedureService', '$stateParams', function (service, $stateParams) {
                        return service.getProcedureForEdit($stateParams.ProcedureType, $stateParams.ProcedureCode);
                    }],
                    metadataBlockLookups: ['procedureService', function (service) {
                        return service.getAllMetadataBlockLookupAttributes();
                    }],
                    businessUnits: ['procedureService', function (service) {
                        return service.getAllBusinessUnits();
                    }]
                },
                views: {
                    'govProcedure@procedure': {
                        template: '<div class="procedure-wrapper row"><div ui-view="govProcedureSections"></div><div ui-view="govProcedureMetadata"></div></div>',
                    },
                    'govProcedureMetadata@procedure.edit.metadata': {
                        resolve: {
                            metadataBlockLookups: ['procedureService', function (service) {
                                return service.getAllMetadataBlockLookupAttributes();
                            }],
                            businessUnits: ['procedureService', function (service) {
                                return service.getAllBusinessUnits();
                            }],
                            procedureTypes: function () { return null; }
                        },
                        templateUrl: require('./procedureEditMetadata.tpl.html'),
                        controller: 'ProcedureEditMetadataController'
                    },
                    'govProcedureSections@procedure.edit.metadata': {
                        templateUrl: require('./procedureSectionListEdit.tpl.html'),
                        controller: 'ProcedureSectionListEditController'
                    }
                }
            })

            // Procedure Edit Reviewers
            .state('procedure.edit.reviewers', {
                url: '/Reviewers',
                views: {
                    'govProcedure@procedure': {
                        template: '<div class="procedure-wrapper row"><div ui-view="govProcedureSections"></div><div ui-view="govProcedureReviewers"></div></div>',
                    },
                    'govProcedureReviewers@procedure.edit.reviewers': {
                        templateUrl: require('./ProcedureEditReviewers.tpl.html'),
                        controller: 'ProcedureEditReviewersController'
                    },
                    'govProcedureSections@procedure.edit.reviewers': {
                        templateUrl: require('./procedureSectionListEdit.tpl.html'),
                        controller: 'ProcedureSectionListEditController'
                    }
                }
            })

            // Procedure Edit Access Rights
            .state('procedure.edit.accessRights', {
                url: '/AccessRights',
                views: {
                    'govProcedure@procedure': {
                        template: '<div class="procedure-wrapper row"><div ui-view="govProcedureSections"></div><div ui-view="govProcedureAccessRights"></div></div>',
                    },
                    'govProcedureAccessRights@procedure.edit.accessRights': {
                        templateUrl: require('./ProcedureEditAccessRights.tpl.html'),
                        controller: 'ProcedureEditAccessRightsController'
                    },
                    'govProcedureSections@procedure.edit.accessRights': {
                        templateUrl: require('./procedureSectionListEdit.tpl.html'),
                        controller: 'ProcedureSectionListEditController'
                    }
                }
            })

			// Responsibility Edit
			.state('responsibility', {
				url: '/Responsibility/{ResponsibilityID:int}',
				params: historyCtxtServiceProvider.getStateParamsConfig(),
				resolve: {
					responsibility: ['$stateParams', 'responsibilityService', function ($stateParams, responsibilityService) {
						return responsibilityService.getResponsibility($stateParams.ResponsibilityID);
					}]
				},
				views: {
					'': {
						template: '<div ui-view="mainContent"></div>',
						controller: 'ProcedureResponsibilityEditController'
					},
					'mainContent@responsibility': {
						templateUrl: require('./procedureResponsibilityEdit.tpl.html')
					}
				}
		    });
    }
})();
